import classNames from 'classnames/bind'
import { useWindowSize } from '@frontend-mono/shared/util-window-size'
import { Icon } from '@frontend-mono/shared/design-system'
import { MouseEventHandler } from 'react'
import { RoadmapNode } from './types'
import { ContentListItem } from '../ui-content-list-item'
import styles from './DetailGuide.module.scss'

const cx = classNames.bind(styles)

type DetailGuideProps = RoadmapNode & {
  onCloseClick: MouseEventHandler<HTMLElement>
}

export const DetailGuide = ({
  title,
  description,
  freeContentList,
  onCloseClick,
}: DetailGuideProps) => {
  const { isDesktopSize } = useWindowSize()
  const hasFreeContentList = (freeContentList?.length ?? 0) >= 1

  return (
    <div
      className={cx('container')}
      role="textbox"
      tabIndex={0}
      onClick={(event) => event.stopPropagation()}
    >
      <button type="button" className={cx('close')} onClick={onCloseClick}>
        <Icon name="close" />
        {isDesktopSize && <span>닫기</span>}
      </button>
      <h1 className={cx('title')}>{title}</h1>
      {description && <p className={cx('description')}>{description}</p>}
      {hasFreeContentList && (
        <>
          <h2 className={cx('listTitle')}>FREE CONTENT</h2>
          <div className={cx('listBox')}>
            {freeContentList?.map((freeContent) => (
              <ContentListItem key={freeContent?.title} {...freeContent} />
            ))}
          </div>
        </>
      )}
    </div>
  )
}
